import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { fetchList, deleteContacts } from '../../../actions/admin/models/contacts';
import { MODELS } from '../../../constants/admin/settings';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import { highestRoleSelector, currentUserSelector } from '../../../selectors/authentication';
import { contextSubjectSelector } from '../../../selectors/admin/context';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { msToTime } from '../../../lib/date.utils';
import { HEADERS } from '../../../constants/admin/tables';
import ContactsEventFilter from '../../../components/admin/forms/contacts/ContactsEventFilter';

class Index extends Component {
    _checkRoles = contact => {
        if (hasPermissions(this.props.currentUser, PERMISSIONS.GOD)) return false;
        const ownLevel = highestRoleSelector(this.props.contextId, this.props.currentUser.roles).level;
        const contactLevel = highestRoleSelector(this.props.contextId, contact.roles).level;
        return ownLevel < contactLevel;
    };

    _transformRows = {
        lastLoginAt: date => msToTime(date, true)
    };

    _getHeaders = () =>
        HEADERS[MODELS.CONTACT].filter(
            header => !header.requiredPermission || hasPermissions(this.props.currentUser, header.requiredPermission)
        );

    render() {
        return (
            <AdminTable
                AdvancedSearchForm={ContactsEventFilter}
                enableSearch={true}
                model={MODELS.CONTACT}
                fetchDataFunction={this.props.fetchList}
                deleteAction={this.props.deleteContacts}
                pagination={true}
                blockRowSelection={this._checkRoles}
                headers={this._getHeaders()}
                transformFunctions={this._transformRows}
            />
        );
    }
}

const mapStateToProps = state => ({
    currentUser: currentUserSelector(state),
    contextId: contextSubjectSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchList, deleteContacts }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withBreadcrumb(Index, () => [BREADCRUMB.CONTACTS]));
